void function (exports, {
    sectionId, formId, typeOptionName, optionNames, discountsTable, priceTable,
    typeOptionIndex, packVariant, i18nHalf, i18nFull
}) {
    typeOptionName = decodeURIComponent(typeOptionName);
    optionNames = JSON.parse(decodeURIComponent(optionNames));
    discountsTable = JSON.parse(decodeURIComponent(discountsTable));
    priceTable = JSON.parse("[" + decodeURIComponent(priceTable).replace(/,$/, "") + "]");
    packVariant = decodeURIComponent(packVariant);
    i18nHalf = decodeURIComponent(i18nHalf);
    i18nFull = decodeURIComponent(i18nFull);
    typeOptionIndex = +typeOptionIndex;


    class DiaperAddCase {
        /**
         * @type {HTMLFormElement | null}
         * @private
         */
        _form = null;
        /**
         * @type {HTMLLabelElement | null}
         * @private
         */
        _halfLabel = null;
        /**
         * @type {HTMLInputElement | null}
         * @private
         */
        _fullLabel = null;
        /**
         * @type {MutationObserver}
         * @private
         */
        _priceObserver;
        /**
         * @type {HTMLElement | null}
         * @private
         */
        _priceContainer = null;
        /**
         * @private
         * @type {QuantityDiscount[]}
         */
        _discounts = [];

        constructor() {
            window.addEventListener("DOMContentLoaded", this._onDOMContentLoaded.bind(this));
            this._priceObserver = new MutationObserver(this._onChangePrice.bind(this));

            if (discountsTable) {
                try {
                    for (const { quantity, amount } of discountsTable) {
                        const discount = QuantityDiscount.parse(quantity, amount);
                        if (discount) this._discounts.push(discount);
                    }
                } catch (error) {
                    console.error("Malformed discounts table", error);
                }
            }
        }

        /**
         * @param {FormDataEvent} event 
         */
        modifyFormData(event) {
            /** @type {RadioNodeList} */
            const type_radios = event.target.elements.namedItem(typeOptionName);
            /** @type {HTMLInputElement} */
            let checked_radio = null;
            for (const input of type_radios) {
                if (input.checked) {
                    checked_radio = input;
                    break;
                }
            }

            const multiplier = +checked_radio.dataset.quantityMultiplier;
            if (isFinite(multiplier)) {
                let quantity = event.formData.get("quantity");
                quantity *= multiplier;
                event.formData.set("quantity", "" + quantity);

                this._addCartAnalytics(multiplier, quantity);
            }
        }

        /**
         * @private
         */
        _onDOMContentLoaded() {
            this._form = document.forms.namedItem(formId);
            this._halfLabel = document.getElementById(`${sectionId}-half_case-label`);
            this._fullLabel = document.getElementById(`${sectionId}-full_case-label`);
            this._priceContainer = document.getElementById(`price-${sectionId}`);
            this._priceObserver.observe(this._priceContainer, { childList: true });
            const quantity = this._form.elements.namedItem("quantity");
            quantity.addEventListener("input", this._onChangePrice.bind(this));
            quantity.addEventListener("change", this._onChangePrice.bind(this));

            const selectedOptions = this._getSelectedOptions();
            this._updateLabels(selectedOptions);
        }

        /**
         * @type {MutationCallback}
         * @private
         */
        _onChangePrice() {
            const selectedOptions = this._getSelectedOptions();
            this._updateLabels(selectedOptions);

            /** @type {RadioNodeList} */
            const type_radios = this._form.elements.namedItem(typeOptionName);
            /** @type {HTMLInputElement} */
            let checked_radio = null;
            for (const input of type_radios) {
                if (input.checked) {
                    checked_radio = input;
                    break;
                }
            }

            /** @type {number} */
            const multiplier = +checked_radio.dataset.quantityMultiplier;
            if (!isFinite(multiplier)) return;

            const quantity = this._form.elements.namedItem("quantity").valueAsNumber;
            const discount = QuantityDiscount.findLargestApplicable(this._discounts, quantity * multiplier);
            const discountMultiplier = discount ? discount.multiplier : 1;

            const priceDom = this._priceContainer.querySelector(".price");
            const prices = this._getPriceForOptions(selectedOptions);
            if (!prices) {
                console.error("Failed to get base price for options", this._getSelectedOptions());
                return;
            }
            const { price, compareAtPrice } = prices;

            /** @type { NodeListOf<HTMLSpanElement> } */
            const priceElements = priceDom.querySelectorAll(":not(.unit-price)>.price-item");

            for (const span of priceElements) {
                let myMultiplier = multiplier;
                let innerPrice;
                if (span.classList.contains("price-item--regular")) {
                    innerPrice = compareAtPrice.clone();
                } else {
                    // Only apply discount for the displayed discounted price
                    myMultiplier *= discountMultiplier;
                    innerPrice = price.clone();
                }

                innerPrice.value *= myMultiplier;
                span.textContent = innerPrice.toString();
            }
            if (discount) {
                // Modify "Sale" badge to show discount instead
                const saleBadge = priceDom.querySelector(".badge.price__badge-sale");
                const isSale = "sale" in priceDom.dataset ? priceDom.dataset.sale === "true" : priceDom.classList.contains("price--on-sale");
                if (saleBadge && !isSale) {
                    saleBadge.style.display = "none";
                }
                if (saleBadge && window.Intl && Intl.NumberFormat) {
                    const discountBadge = priceDom.querySelector(".badge.price__badge-discount") || document.createElement("span");
                    const cls = discountBadge.classList;
                    cls.add("color-accent-1");
                    cls.add("badge");
                    cls.add("price__badge-discount");
                    discountBadge.style.marginLeft = isSale ? "1rem" : "";

                    // recalculate percent based on already reduced base price (sale and quantity discount)
                    const discountPercent = 1 - (price.value * discountMultiplier) / compareAtPrice.value;
                    const discountText = new Intl.NumberFormat([], {
                        unit: "percent",
                        unitDisplay: "short",
                        style: "percent",
                        maximumFractionDigits: 1,
                    }).format(-discountPercent);
                    discountBadge.textContent = ` ${discountText} `;
                    saleBadge.insertAdjacentElement("afterend", discountBadge);
                }
                // Display struck-through price
                priceDom.dataset.sale = isSale;
                priceDom.classList.add("price--on-sale");
            }

            this._addButtonAnalytics(multiplier);
        }

        /**
         * @private
         * @returns {string[]}
         */
        _getSelectedOptions() {
            const options = [];
            for (const optionName of optionNames) {
                options.push(this._form.elements.namedItem(optionName).value);
            }
            return options;
        }

        /**
         * @private
         * @param {string[]} options
         * @returns {null | {price: Price, compareAtPrice: Price}}
         */
        _getPriceForOptions(options) {
            let i;
            outer: for (const variant of priceTable) {
                for (i = 0; i < options.length; i++) {
                    if (variant.options[i] !== options[i]) continue outer;
                }
                // Found variant
                const price = Price.parse(variant.price);
                return {
                    price,
                    compareAtPrice: price.clone(),
                    //compareAtPrice: Price.parse(variant.compare_at_price),
                };
            }
            return null;
        }

        /**
         * @private
         * @param {string[]} options
         */
        _updateLabels(options) {
            options = [...options];
            options[typeOptionIndex] = packVariant;
            let i;
            outer: for (const variant of priceTable) {
                for (i = 0; i < options.length; i++) {
                    if (variant.options[i] !== options[i]) continue outer;
                }
                // Found variant
                const amount = +variant.sku.split("-")[1]; // Get amount from SKU
                const halfInput = document.getElementById(this._halfLabel.htmlFor);
                const fullInput = document.getElementById(this._fullLabel.htmlFor);
                if (halfInput)
                    this._halfLabel.textContent = i18nHalf.replace("#AMOUNT#", amount * halfInput.dataset.quantityMultiplier);
                if (fullInput)
                    this._fullLabel.textContent = i18nFull.replace("#AMOUNT#", amount * fullInput.dataset.quantityMultiplier);
                return;
            }
        }

        /**
         * @private
         * @param {number} quantityPerCase
         * @param {number} quantity
         */
        _addCartAnalytics(quantityPerCase, quantity) {
            try {
                Shopify.analytics.publish("add_diaper_case_to_cart", {
                    quantity_per_case: quantityPerCase,
                    number_of_cases: quantity,
                });
            } catch (error) {
                console.error("Error while publishing analytics event:", error);
            }
        }

        /**
         * @private
         * @param {number} quantityPerCase
         */
        _addButtonAnalytics(quantityPerCase) {
            try {
                Shopify.analytics.publish("select_diaper_case_variant", {
                    quantity_per_case: quantityPerCase,
                });
            } catch (error) {
                console.error("Error while publishing analytics event:", error);
            }
        }
    };

    class Price {
        /** @type {string} */
        prefix = "";
        /** @type {string} */
        suffix = "";
        /** @type {string | undefined} */
        decimalPoint;
        /** @type {number} */
        decimalPlaces = 0;
        /** @type {number} */
        value = 0;

        /**
         * @returns {string}
         */
        toString() {
            let str = this.prefix;
            const numStr = "" + Math.round(this.value);
            if (typeof this.decimalPoint === "string") {
                str += numStr.length > this.decimalPlaces ? numStr.substring(0, numStr.length - this.decimalPlaces) : "0";
                str += this.decimalPoint;
                str += numStr.substring(numStr.length - this.decimalPlaces).padStart(this.decimalPlaces, "0");
            } else {
                str += numStr;
            }
            str += this.suffix;
            return str;
        }

        /**
         * @returns {Price}
         */
        clone() {
            let copy = new Price();
            copy.prefix = this.prefix;
            copy.suffix = this.suffix;
            copy.decimalPoint = this.decimalPoint;
            copy.decimalPlaces = this.decimalPlaces;
            copy.value = this.value;
            return copy;
        }

        /**
         * @type {RegExp}
         * @private
         */
        static _PRICE_REGEX = /^(?<prefix>[^\d]*)(?<amount>\d+)(?:(?<decimal>[.,])(?<cents>\d+))?(?<suffix>[^\d]*)$/;

        /**
         * @param {string} str
         * @returns {Price | null}
         */
        static parse(str) {
            const matches = this._PRICE_REGEX.exec(str);
            if (matches === null) return null;

            const groups = matches.groups;

            const price = new this();
            price.prefix = groups.prefix;
            price.suffix = groups.suffix;
            price.value = +groups.amount;

            if (groups.decimal) {
                price.decimalPoint = groups.decimal;
                price.decimalPlaces = groups.cents.length;
                const factor = 10 ** price.decimalPlaces;
                price.value *= factor;
                price.value += +groups.cents;
            }

            return price;
        }
    }

    class QuantityDiscount {
        /** @type {number} */
        quantityStart;
        /** @type {number} */
        quantityEnd;
        /** @type {number} */
        multiplier;

        /**
         * @param {number} multiplier
         * @param {number} quantityStart
         * @param {number} quantityEnd
         */
        constructor(multiplier, quantityStart, quantityEnd = Infinity) {
            this.quantityStart = quantityStart;
            this.quantityEnd = quantityEnd;
            this.multiplier = multiplier;
        }

        /**
         * @param {number} quantity
         * @returns {boolean}
         */
        isApplicableToQuantity(quantity) {
            return quantity >= this.quantityStart && quantity <= this.quantityEnd;
        }

        static _QUANTITY_REGEX = /\d+/g;
        static _DISCOUNT_REGEX = /^(\d+(?:[.,]\d+)?)%/;

        /**
         * @param {string} strQuantity
         * @param {string} strDiscount
         * @returns {QuantityDiscount | null}
         */
        static parse(strQuantity, strDiscount) {
            const [startMatch, endMatch] = strQuantity.matchAll(this._QUANTITY_REGEX);

            if (!startMatch) return null;
            const start = +startMatch[0];

            const end = endMatch ? +endMatch[0] : undefined;

            const discountMatch = strDiscount.match(this._DISCOUNT_REGEX);
            if (!discountMatch) return null;

            const discount = +discountMatch[1].replace(",", ".");

            return new this(1 - discount / 100, start, end);
        }

        /**
         * @param {readonly QuantityDiscount[]} discounts
         * @param {number} quantity
         * @returns {QuantityDiscount | null}
         */
        static findLargestApplicable(discounts, quantity) {
            /** @type {QuantityDiscount | null} */
            let discount = null;
            discounts
                .filter(it => it.isApplicableToQuantity(quantity))
                .forEach(it =>
                    discount = !discount
                        ? it
                        : discount.multiplier > it.multiplier ? it : discount
                );
            return discount;
        }
    }

    exports.diaperAddCase = new DiaperAddCase();
}(window, document.currentScript.dataset);

